/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { addOrRemoveJinglesToCollectionModelSchema } from "../addOrRemoveJinglesToCollectionModelSchema.ts";
import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

export const postApiJingleCollectionsIdJinglesPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор подборки")
    })

/**
 * @description Успешно
 */
export const postApiJingleCollectionsIdJingles200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const postApiJingleCollectionsIdJingles400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const postApiJingleCollectionsIdJingles401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const postApiJingleCollectionsIdJingles403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Not Found
 */
export const postApiJingleCollectionsIdJingles404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const postApiJingleCollectionsIdJingles500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const postApiJingleCollectionsIdJinglesMutationRequestSchema = z.lazy(() => addOrRemoveJinglesToCollectionModelSchema).describe("Тело запроса")

export const postApiJingleCollectionsIdJinglesMutationResponseSchema = z.lazy(() => postApiJingleCollectionsIdJingles200Schema)